import React from 'react';
import { Helmet } from 'react-helmet-async';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

import { UI } from 'src/features/transfer/constants';
import NewHeader from 'src/layouts/new-header/NewHeader';
import NewFooter from 'src/layouts/new-footer/NewFooter';
import TransactionsView from 'src/features/transactions/view/TransactionsView';

// Client-only Transactions page.
// Wraps the SHARED TransactionsView in the new-design chrome (own header/footer,
// dark background + green glow). The original src/pages/Transactions.jsx and
// TransactionsView are untouched, so the admin dashboard is unaffected.

export default function ClientTransactions() {
  return (
    <>
      <Helmet>
        <title>SafiSwap | Transactions</title>
      </Helmet>

      <Box
        sx={{
          bgcolor: UI.bg,
          color: UI.text,
          minHeight: '100vh',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: -200,
            left: -160,
            width: 1000,
            height: 1000,
            background: `radial-gradient(circle, ${UI.green}22 0%, transparent 60%)`,
            pointerEvents: 'none',
            zIndex: 0,
          },
          '& > *': {
            position: 'relative',
            zIndex: 1,
          },
        }}
      >
        <NewHeader />

        <Box component="main" sx={{ flexGrow: 1 }}>
          <Container maxWidth="lg" sx={{ pt: { xs: 4, md: 7 }, pb: { xs: 8, md: 10 } }}>
            <TransactionsView />
          </Container>
        </Box>

        <NewFooter />
      </Box>
    </>
  );
}
